import { useAuth } from 'hooks/useAuth';
import { ROLES } from 'constants/index';
import {
  visibleColumnIds,
  columnsConfig,
  availableColumns,
  FRAUD_CHECK_COLUMN
} from './columnsConfig';

export default function useGetTableColumns(key) {
  const { userSettings, viewAsRole } = useAuth();
  const selectedColumnIds = userSettings[key]?.selectedColumns || [];

  // Drop admin-only columns for other roles, including from saved column settings.
  const forRole = columnIds =>
    viewAsRole === ROLES.ADMIN ? columnIds : columnIds.filter(id => id !== FRAUD_CHECK_COLUMN);

  return {
    defaultVisibleColumnIds: forRole(visibleColumnIds),
    visibleColumnIds: forRole(selectedColumnIds.length > 0 ? selectedColumnIds : visibleColumnIds),
    availableColumns: columnsConfig.filter(item =>
      forRole(availableColumns).includes(item.accessor)
    )
  };
}
